import { IReport } from '../store/reports/types'
import _ from 'lodash'

export type SortByValue =
  | 'mostRecent'
  | 'alphabetically'
  | 'subjectLastName'
  | 'location'
  | 'caseNumber'
  | 'tierLevel'
  | string

export function isEmptyObj(obj: Record<string, any>): boolean {
  return Object.keys(obj).length === 0
}

/**
 * Sort reports by most recent date
 * */
const sortByRecentDate = (a: IReport, b: IReport) => {
  const dateA: Date = new Date(a.created_at)
  const dateB: Date = new Date(b.created_at)
  return dateB.getTime() - dateA.getTime()
}

export const sortedData = (data: IReport[], sortByWatchValue: SortByValue) => {
  switch (sortByWatchValue) {
    case 'mostRecent':
      return [...data].sort(sortByRecentDate)
    case 'alphabetically':
      return _.orderBy([...data], ['name'], ['asc'])
    case 'subjectLastName':
      if ([...data].length) {
        return _.orderBy(
          [...data],
          user =>
            _.flatMap(user.subjects, fullName => {
              if (fullName['full_name']) {
                const lastName = fullName['full_name'].split(' ')[1] || fullName['full_name'].split(' ')[0] || ''
                return lastName.toLowerCase()
              }
            }),
          ['asc'],
        )
      }
      return [...data]
    case 'location':
      // TODO figure out by which location to sort since report does not contains any location prop
      // return _.orderBy([...data], ['unique_code'], ['asc'])
      return [...data]
    case 'caseNumber':
      return _.orderBy([...data], ['uuid'], ['asc'])
    case 'tierLevel':
      return _.orderBy([...data], ['tier_level'], ['asc'])
    default:
      return data
  }
}

/**
 * Creating flag for the founded item
 * @param query Search string
 * @param obj Single report object that is going to be looped
 * @returns true/false
 */
const isQueryIncluded = (query: any, obj: any) => {
  for (const key in obj) {
    if (_.isArray(obj[key]) || _.isObject(obj[key])) {
      if (isQueryIncluded(query, obj[key])) {
        return true
      }
    } else {
      if (_.includes(_.toString(obj[key]).toLowerCase(), query)) {
        return true
      }
    }
  }
  return false
}

/**
 * Filtering cases per specific group
 * @param reports Array of reports per specific group
 * @param query Query string that is going to serve as filter
 * @returns
 */
export const filterReports = (reports: IReport[], query: string) => {
  return reports.filter(report => isQueryIncluded(query.toLowerCase(), report))
}
